import React from 'react'
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from 'react-router-dom';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
function MobilePayNow() {
    const navigate = useNavigate();
  return (
    <div className='MainView'>
    <div className="drawerWithTop">
        {/* <MobileDrawer /> */}
        <ArrowBackIcon
        className="backArrowMobil"
        onClick={() => navigate("/MobileUnpaidInvoiceDetails")}
        />
        <h1>Pay Now</h1>
    </div>
    <div className='topSpace'></div>
    <div className='invoiceNameTile'>
        <div className='nameViewInvoice'>
            <p className='nameTxtInvoice'>Bill No :</p>
            <p className='userNameTxtInvoice'>10145</p>
        </div>
        <div className='nameViewInvoice'>
            <p className='nameTxtInvoice'>Bill Date :</p>
            <p className='userNameTxtInvoice'>05/10/2023</p>
        </div>
        <div className='nameViewInvoice'>
            <p className='nameTxtInvoice'>Due Date :</p>
            <p className='userNameTxtInvoice'>31/12/2023</p>
        </div>
        <div className='nameViewInvoice'>
            <p className='nameTxtInvoice'>Period :</p>
            <p className='userNameTxtInvoice'>01/06/2023 to 31/09/2023</p>
        </div>
    </div>
    <div className='marginHorizontalCommon margineTopAdd'>
    <div className='famDetailsListInrMob greenPanelInvoice'>
        <div className='famDetailsListTo'>
            <p className='userNameTxtInvoice txtColorWhite'>Total Payable</p> 
            <p className='priceTxt txtColorWhite'><CurrencyRupeeIcon sx={{fontSize:15, fontWeight:700}}/> 1049</p>
        </div>
    </div>
    <div className='famDetailsListInrMob'>
        <p className='bankDetailsTxt'>Payment Option</p>
        <div className='famDetailsListTo'>
            <p className='userNameTxtInvoice'>UPI</p> 
            <CheckCircleOutlineIcon sx={{fontSize:25}}/>
        </div>
        <div className='dividerCommon' />
        <div className='famDetailsListTo'>
            <p className='userNameTxtInvoice'>UPI</p> 
            <CheckCircleOutlineIcon sx={{fontSize:25}}/>
        </div>
        <div className='dividerCommon' />
        <div className='famDetailsListTo'>
            <p className='userNameTxtInvoice'>UPI</p> 
            <CheckCircleOutlineIcon sx={{fontSize:25}}/>
        </div>
    </div>        
    </div>
    <div className='topSpace'></div>
      <div className='bottomBtnView'>
        <button className='submitButton' onClick={()=>navigate('/Invoice')}>Proceed to Pay</button>
      </div>
    </div>
  )
}

export default MobilePayNow